module.exports = __webpack_public_path__ + "img/free-slot-black.6fc2341e.svg";